<div 
  class="fixed bg-[url(/assets/bg-menu-img.png)] left-0 top-0 h-screen backdrop-blur-xl text-white shadow-2xl transition-all duration-500 ease-in-out z-50 border-r border-white/10"
  [ngClass]="{
    'w-0 opacity-0 pointer-events-none': sidebarMode === 'hidden',
    'w-24': sidebarMode === 'narrow' && !isHovering,
    'w-72': sidebarMode === 'expanded' || (sidebarMode === 'narrow' && isHovering)
  }"
  (mouseenter)="onSidebarHover(true)"
  (mouseleave)="onSidebarHover(false)"
  >
  <!-- Toggle Button -->
<div class="flex justify-end p-2 fixed top-0 -right-5 z-[60]">
  <button
    (click)="toggleSidebar()"
    class="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-all duration-300"
    pTooltip="Toggle Sidebar"
  >
    <i
      class="pi"
      [ngClass]="{
        'pi-angle-double-left': sidebarMode === 'expanded',
        'pi-angle-double-right': sidebarMode === 'narrow'
      }"
    ></i>
  </button>
</div>

  <div class="flex flex-col h-full ">
    
    <div class="p-2 transition-all duration-500" *ngIf="sidebarMode === 'expanded' || isHovering">
      <div class="w-[95%] relative overflow-hidden bg-white rounded-3xl p-2 border border-blue-100 text-center group">
        <!-- <div class="absolute -top-12 -left-12 w-32 h-32 bg-white/20 rounded-full blur-2xl group-hover:bg-blue-400/40 transition-all"></div> -->
        
        <div class="relative mx-auto w-32 h-32 mb-2 bg-white rounded-t-full border-t-[3px] border-blue-950/70">
          <img src="assets/iima_logo.png" class="w-full h-full rounded-t-full   object-cover bg-white " />
          <!-- <img src="assets/iima_logo.png" class="w-full h-full rounded-t-full   object-cover bg-white " /> -->
        </div>

        <div >
          <p class="text-sm font-semibold text-slate-800">P.No: {{user.login_name}}</p>
          <p class="text-sm text-slate-700 font-semibold">Name: {{user.f_name +" "+ user.l_name}}</p>
          <div class="mt-2 inline-block px-3 py-1 bg-blue-100 rounded-full border border-blue-200">
            <span class="text-[10px] font-bold uppercase text-blue-900">Role: {{user.role}}</span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="sidebarMode === 'narrow' && !isHovering" class="flex justify-center py-10">
      <div class="w-14 h-14 rounded-2xl bg-white/10 border border-white/30 flex items-center justify-center shadow-2xl">
        <img src="assets/iima_logo.png" class="w-10 h-10 object-contain" />
      </div>
    </div>

    <div class="flex-1 overflow-y-auto px-4 py-4 custom-scrollbar">
      <ul class="space-y-4">
        <li *ngFor="let item of originalMenuItems" class="relative">
          <a *ngIf="checkPermission(item.privileges)"
             href="javascript:void(0);" 
             (click)="onMenuItemClick(item)"
             class="group border-2 relative flex items-center gap-4 p-2 rounded-[1.25rem] transition-all duration-500 overflow-hidden"
             [ngClass]="{
               'bg-white/20 border-white/40 shadow-lg scale-[1.02]': activeSubmenuIndex?.url === item.url,
               'hover:bg-white/5 border-white/70 border-transparent': activeSubmenuIndex?.url !== item.url,
               'justify-center': sidebarMode === 'narrow' && !isHovering
             }">
            
            <div class="relative w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-[1rem] transition-all duration-700 z-10"
                 [ngClass]="activeSubmenuIndex?.url === item.url ? 'bg-blue-500 shadow-[0_0_20px_rgba(59,130,246,0.5)] scale-110' : 'bg-white/10 group-hover:rounded-[1.5rem]'">
              <span class="text-sm font-black text-white">{{ item.name.charAt(0) }}</span>
            </div>
            
            <span *ngIf="sidebarMode === 'expanded' || isHovering"
                  class="text-xs font-bold tracking-[0.15em] text-white/80 group-hover:text-white transition-colors uppercase">
              {{ item.name }}
            </span>

            <div class="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
          </a>
        </li>
      </ul>
    </div>
  
  </div>
</div>

<style>
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: rgb(30 41 59);
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgb(51 65 85);
  border-radius: 3px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgb(71 85 105);
}
</style>